import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mixins from "./mixins"
import { Toast, Form, Field, Button, Dialog, Empty, Loading, Divider, Swipe, SwipeItem, DatetimePicker, Popup, Icon, ImagePreview, Picker } from 'vant';
import 'vant/lib/index.css';
Vue.config.productionTip = false
Vue.mixin(mixins)
Vue.use(Toast).use(Form).use(Field).use(Button).use(Dialog).use(Empty).use(Loading).use(Divider).use(Swipe).use(SwipeItem).use(DatetimePicker).use(Popup).use(Icon).use(ImagePreview).use(Picker)

const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 安卓调用的返回
window.back = () => {
  if((store.state.userRole == 1 && store.state.userRole == 2) || vm.$route.path == '/flowPath/index')return JS.close();
  if (vm.$route.meta.index == 1 || vm.$route.path == store.state.startRouter) {
      JS.close()
  } else {
      router.go(-1)
      return true
  }
}
window.takePhotoResult = (res) => {
  console.log(res,"res")
}

require('@/utils/methods')